import * as actionTypes from './actionTypes';

export const setIsLoadingLogin = (isLoadingLogin) => {
  return {
    type: actionTypes.SET_IS_LOADING_LOGIN,
    isLoadingLogin: isLoadingLogin,
  };
};
